"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Register(_a) {
    var user = _a.user;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    var _c = ra_fetch_1.useApi('backend').store('channels', {
        label: '',
        type: 'club',
        sport_id: '',
        user_id: user.id,
        role: 'admin',
    }), channel = _c[0], setChannel = _c[1], submitChannel = _c[2];
    function onSubmit() {
        submitChannel().then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: 'Je kanaal is succesvol geregistreerd', returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos?channel_id=" + response.data.id }); }
                });
            }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Forms.Title, null, "Registreer je kanaal"),
            react_1.default.createElement(storybook_1.Channels.FormFields, { channel: channel.data, setChannel: setChannel, user: user, submit: submitChannel, type: {
                    label: 'Kanaal',
                    url: 'kanalen',
                    name: 'channel',
                } }),
            react_1.default.createElement(storybook_1.Forms.Buttons, { errors: channel.errors, loading: channel.submitting, submit: onSubmit }))));
}
function ChannelPicker(_a) {
    var user = _a.user, plan = _a.plan;
    var channels = ra_fetch_1.useApi('backend').index('user.channels', { id: user.id })[0];
    var _b = react_1.useState({}), owner = _b[0], setOwner = _b[1];
    if (channels.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var errors = [];
    if (owner.role && owner.role.name !== 'admin') {
        errors = [{ message: "Alleen de beheerder van het gekozen kanaal kan een " + plan.label + " abonnement afnemen" }];
    }
    var preview = process.env.NEXT_PUBLIC_STORYBOOK_SUBSCRIPTIONS_PREVIEW;
    if (preview) {
        errors = [{ message: "Eyecons PRO is beschikbaar vanaf " + preview }];
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null,
            "Starten met ",
            plan.label),
        !preview && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Select, { value: owner.id, onChange: function (channel_id) { return setOwner(channels.data.findBy('id', Number(channel_id))); } },
                    react_1.default.createElement("option", null, "Kies een kanaal"),
                    channels.data.map(function (channel, index) { return react_1.default.createElement("option", { value: channel.id, key: index }, channel.label); }))),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Texts.Small, null, "Kies hierboven uit \u00E9\u00E9n van jou kanalen, voor een nieuw kanaal dien je die eerst te registreren als freemium kanaal."))),
        react_1.default.createElement(storybook_1.Subscriptions.FormButtons, { errors: errors, owner_id: owner.id, plan: plan, params: { trail: 30 }, disabled: preview || !channels.data.length }));
}
function Save(_a) {
    var user = _a.user, _b = _a.plan, plan = _b === void 0 ? {} : _b;
    if (!plan.id) {
        return react_1.default.createElement(Register, { user: user });
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChannelPicker, { user: user, plan: plan }));
}
exports.default = Save;
